import { BuilderArticlePageReference } from '@/types/article';
import { BuilderState } from '@/types/builder';
import { CategoryLabelVariant } from '../CategoryLabel/CategoryLabel';

export const FEATURED_ARTICLES_NAME = 'FeaturedArticles';
export const FEATURED_ARTICLES_DEFAULT_LIMIT = 9;

export enum FeaturedArticlesLayoutType {
  Featured = 'featured',
  Standard = 'standard',
}

export interface FeaturedArticlesInput {
  title: string;
  layout: FeaturedArticlesLayoutType;
  // when true, fetches latest articles automatically and when false, uses manually selected articles.
  autoSelectLatest?: boolean;
  // maximum number of articles to display (only used when autoSelectLatest is true).
  limit?: number;
  // manually selected articles (only used when autoSelectLatest is false).
  articles?: {
    article?: BuilderArticlePageReference;
  }[];
  builderState: BuilderState;
  tagVariant?: CategoryLabelVariant;
}
